import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { isElement } from 'Utils/UtilityFunctions';
import {
  maxMobile,
  maxWidth, primaryFont, primaryHeadingColor, retina, secondaryFont, wMedium,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  z-index: 0;
  display: flex;
  .updated-tip {
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    line-height: 19px;
    color: ${primaryHeadingColor};
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 13px; 
    }
    &.date {
      font-family: ${secondaryFont};
    }
  }
  .separator {
    @media all and (max-width: ${maxMobile}) {
      display: inline-flex;
      border-right: 1px solid rgb(126, 126, 126);
      height: 20px;
      margin: 0px 2px 0 7px;
    }
  }
  
`;

type Props = {
  date?: string;
} & typeof defaultProps;

const defaultProps = {
  date: '',
};

const UpdatedPill = function UpdatedPill(props: Props) {
  const { section } = useParams();
  const {
    date,
  } = props;

  useEffect(() => {
    const element: HTMLElement | null = document.getElementById('tabs-details');
    if (element && section === 'swot') {
      isElement(element, -120);
    }
  }, []);

  return (
    <Wrapper className="head-trigger">
      <span className="updated-tip">
        Updated:
        {' '}
        <span className="updated-tip date">
          {date}
        </span>
      </span>
      <span className="separator" />
    </Wrapper>
  );
};

UpdatedPill.defaultProps = defaultProps;
export default UpdatedPill;
